/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Ad_Render_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to render text-to-speech: {error}" |
*
* @param {Shortcut_Keys_Ad_Render_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_render_failed_toast = /** @type {((inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Render_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du rendu en synthese vocale : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Rendern von Text-zu-Sprache: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eseguire il rendering del testo in voce: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось выполнить преобразование текста в речь: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al convertir texto a voz: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文本转语音渲染失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`テキスト読み上げのレンダリングに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टेक्स्ट-टू-स्पीच को रेंडर करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao converter texto em fala: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to render text-to-speech: ${i?.error}`)
});